import { code, entrypoint, viewOf } from "../../client/index.ts";

const empresa = viewOf("empresa");

export const below = code(() => import("./parts/lower.tsx"));

export function scopeView<M>(view: () => Promise<M>): (opening: boolean) => Promise<M> {
  return (opening) => {
    if (!opening) void below.load().catch(() => undefined);
    return view();
  };
}

export const scopeExploration = ["dias", "ver"];

export const entrypoints = [entrypoint({
  id: "visao-geral",
  path: "/",
  level: "empresa",
  replaceOn: scopeExploration,
  data: (_, query) => empresa({}, { dias: query.get("dias") ?? undefined }),
  view: scopeView(() => import("./view.tsx")),
  place: (data) => ({ title: data.scope.name, self: data.scope, path: data.path }),
})];
